if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"main","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return !/^(1(84[17]|003|415|528)|2([19]59|173|443|511|914)|3(4(30|32|91)|(|8)91|137|15|389|709)|4(72[39]|09|190|595|694|99)|5(151|291|323|489|517|634|772|79)|6(49(|8)|5(34|79|9)|058|285|815|930)|7(58[157]|9(45|87|89)|007|069|273|302|435|68|727)|8(4(43|61|9)|147|196|528|579|769|861)|9(17|209|381|47|536|789))$/.test(chunkId)},
		rootOutputDir: "",
		bundlerRuntimeOptions: { remotes: { remoteInfos: {}, webpackRequire: __webpack_require__,idToRemoteMap: {}, chunkMapping: {},idToExternalAndNameMapping: {} } }
	};
__webpack_require__.consumesLoadingData = {}
__webpack_require__.remotesLoadingData = {}
}